//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Hero from './components/Hero.vue'
import Tabs from './components/Tabs.vue'
import Filters from './components/Filters.vue'
import Title from './components/Title.vue'
import Tags from './components/Tags.vue'
import Result from './components/Result.vue'
import Pagination from './components/Pagination/Pagination.vue'

export default {
  name: "SearchApp",
  components: {
    Hero,
    Tabs,
    Title,
    Filters,
    Tags,
    Result,
    Pagination,
  },
  data() {
    return {
      railRemoved: false,
      headerRemoved: false
    }
  },
  computed:{
    gridClasses() {
      let classes = [];
      if (this.options.hideRail) {
        classes.push('search--norail');
      }
      return classes.join(' ');
    }
  },
  methods: {
    toggleRail() {
      this.railRemoved = !this.railRemoved;
    },
    toggleHeader() {
      this.headerRemoved = !this.headerRemoved;
    }
  }
};
